<ion-header class="ion-no-border">
  <ion-toolbar>
    <!--
    To make sure the logo is centered add a placeholder <ion-buttons>
    with `slot="start"` and the same content as the <ion-buttons> with
    `slot="end"`.
    -->
    @if (isAuthenticated()) {
      <ion-buttons slot="start" class="placeholder">
        <ion-button color="primary">
          <ion-icon name="information-circle-outline" />
        </ion-button>
      </ion-buttons>
    }

    <ion-title>
      <img src="assets/icon/logo.svg" />
    </ion-title>

    <!--
    Make sure when updating the following <ion-buttons> to update
    the <ion-buttons> with `slot="start"` as well to keep the logo
    aligned in the center of the page.
    -->
    @if (isAuthenticated()) {
      <ion-buttons slot="end">
        <ion-button color="primary" (click)="logout()">
          <ion-icon name="log-out-outline" slot="icon-only" />
        </ion-button>
      </ion-buttons>
    }
  </ion-toolbar>
</ion-header>
